export default {
  prompts: [],
  prompt: undefined,
};
